/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { SeoLocation } from './model/seoLocation';

/**
 * SEO Location View for BrandLocalityService
 */
export const apiSearchSeoNeighborhoodRetrieve = (
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocation>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`,
    method: 'GET',
    signal,
  });
};

export const getApiSearchSeoNeighborhoodRetrieveQueryKey = (
  countryUrlPrefix?: string,
  neighborhood?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string,
  extra?: string
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`,
  ] as const;
};

export const getApiSearchSeoNeighborhoodRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSearchSeoNeighborhoodRetrieveQueryKey(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>> = ({
    signal,
  }) =>
    apiSearchSeoNeighborhoodRetrieve(
      countryUrlPrefix,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && neighborhood && city && regionSlug && seoSlug && extra),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiSearchSeoNeighborhoodRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>
>;
export type ApiSearchSeoNeighborhoodRetrieveQueryError = ErrorType<unknown>;

export function useApiSearchSeoNeighborhoodRetrieve<
  TData = Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSearchSeoNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSearchSeoNeighborhoodRetrieveQueryOptions(
    countryUrlPrefix,
    neighborhood,
    city,
    regionSlug,
    seoSlug,
    extra,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
